import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import T from "prop-types";
import * as actions from "./actions";

const withSubscription = WrappedComponent => {
  class WithSubscription extends React.Component {
    static propTypes = {
      refresh: T.func.isRequired,
      setFresh: T.bool.isRequired
    };

    componentWillReceiveProps(nextProps) {
      if (nextProps.stale && !nextProps.loading) {
        this.props.refresh().then(() => {
          this.props.setFresh();
        });
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithSubscription;
};

export default function subscribeTo(key) {
  return Component =>
    connect(
      state => ({
        stale: _.get(state.subscriptions.toJS(), `${key}.stale`, false)
      }),
      dispatch => ({
        setFresh: () => dispatch(actions.setFresh(key))
      })
    )(withSubscription(Component));
}



// WEBPACK FOOTER //
// ./app/modules/Subscription/withSubscription.jsx